<template>
    <div>
      <v-data-table
        :page.sync="meta.current_page"
        :server-items-length="meta.total"
        :loading="isFetching"
        :headers="headers"
        :items="organizations"
        :items-per-page.sync="meta.per_page"
        class="elevation-1"
      >
          <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-toolbar-title>Организации</v-toolbar-title>
          </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
              <v-icon
                small
                @click="() => $refs['dialogConfirm'+ item.id].show()"
              >
                  mdi-delete
              </v-icon>
              <dialog-confirm :ref="'dialogConfirm' + item.id"
                              @confirm="() => onRemove(item)"
                              :text="'Вы действительно хотите удалить организацию ' + item.short_name + '?'"
                              title="Удаление организации"
              ></dialog-confirm>
          </template>
          <template v-slot:no-data>
              <v-btn
                      color="primary"
                      @click="initialize"
              >
                  Reset
              </v-btn>
          </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as api from '@/api/admin/workspaces';
import * as apiOrganization from '@/api/admin/organization';
import DialogConfirm from "../../DialogConfirm.vue";
export default {
    name: 'WorkspaceOrganizations',
    components: {DialogConfirm},
    props: {
      workspaceId: {
          type: Number,
          require: true
      }
    },
    data: () => ({
        headers: [
          { text: 'id', value: 'id' },
          { text: 'ИНН', value: 'inn' },
          { text: 'Название', value: 'short_name' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],
        isFetching: false,
        organizations: [],
        meta: {},
    }),
    created () {
        this.load(this.workspaceId);
    },
    watch: {
        'meta.current_page': function (newVal, oldVal){
            if(newVal !== oldVal){
                this.load(this.workspaceId);
            }
        },
        'meta.per_page': function (newVal, oldVal){
            if(newVal !== oldVal){
                this.load(this.workspaceId);
            }
        },
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_RESPONSE_ERROR']),
        ...mapActions('organizationList', ['RELOAD']),

        async onRemove(item){
            try{
                let response = await apiOrganization.remove(item.id)
                this.SHOW_SUCCESS(response.data.message);
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка удаления ('});
                console.log(e);
            }finally {
                this.RELOAD();
                this.load(this.workspaceId);
            }
        },
        setFetchState(){
            this.isFetching = true;
            this.setOrganizations([]);
        },
        setMeta(data){
            data.per_page = parseInt(data.per_page);
            this.meta = {...this.meta, ...data};
        },
        async load(workspaceId){
            try{
                this.setFetchState();
                let response = await api.organizations(workspaceId, {page: this.meta.current_page, per_page: this.meta.per_page});
                this.setOrganizations(response.data.data);
                this.setMeta({...response.data, data: null});
            }catch(err){
                console.log(err);
            }finally{
                this.isFetching = false;
            }
        },
        setOrganizations(data){
            this.organizations.splice(0, this.organizations.length, ...data);
        }
    },
    computed:{
    },
}
</script>